import { render, staticRenderFns } from "./OnboardingPage.vue?vue&type=template&id=8dec1832&scoped=true&"
import script from "./OnboardingPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPage.vue?vue&type=style&index=0&id=8dec1832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dec1832",
  null
  
)

export default component.exports